module.exports = "<mat-tab-group>\n  <mat-tab label=\"Personal\">\n    <personal-profile></personal-profile>\n  </mat-tab>\n  <mat-tab label=\"Professional\">\n    <professional-profile></professional-profile>\n  </mat-tab>\n  <mat-tab label=\"Account\">\n\n  </mat-tab>\n</mat-tab-group>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/providers/profile-tabs.component.html
// module id = ./src/app/providers/profile-tabs.component.html
// module chunks = main